import { GiftCardNotifications } from '../Components/NotificationComp.jsx';
import { AdminMessages } from '../Components/ContactComponent.jsx';

const RenderRequests = () => {
  return (
    <div>
      <GiftCardNotifications />
      <AdminMessages />
    </div>
  );
};

export { RenderRequests };
